<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['sourceStorageRoom.name']" :placeholder="$t('business.label.replenishSourceStorageRoom')" @pressEnter="search" @search="search"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :export-config="{}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>this.edit(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="sourceStorageRoom.name" title="business.label.replenishSourceStorageRoom"/>
      <vxe-column field="targetStorageRoom.name" title="business.label.replenishTargetStorageRoom"/>
      <vxe-column field="times" title="business.label.obtainTimes"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:transmissionTypes}" field="transmissionType" title="business.label.transmissionType"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="handover" title="business.label.handover" width="70"/>
      <vxe-column fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <storage-room-replenishment-rule-modal ref="replenishmentRuleModal" :transmission-types="transmissionTypes" @saveSuccess="refresh()"/>
  </a-layout>
</template>

<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import StorageRoomReplenishmentRuleModal from '@/views/basedata/storageroom_maintenance/StorageRoomReplenishmentRuleModal.vue'

export default {
  name: 'StorageRoomReplenishmentRuleTable',
  components: { StorageRoomReplenishmentRuleModal },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'sourceStorageRoom.name': '',
        'targetStorageRoom.name': ''
      },
      storageRoom: null,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.775)// 表格竖向滚动条
    }
  },
  props: {
    transmissionTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    refresh(record) {
      if (record) {
        let args = { 'targetStorageRoom.ids': [record.id] }
        this.storageRoom = record
        Object.assign(this.query, args)
      }
      if (this.storageRoom === null || this.storageRoom === undefined) {
        return this.$message.warning('请先选择补入库房')
      }
      this.loading = true
      findAll('replenishmentRuleFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.page = 1
      this.refresh()
    },
    reset() {
      this.query['sourceStorageRoom.name'] = ''
      this.page = 1
      this.size = 20
      this.refresh()
    },
    edit(record) {
      this.$refs.replenishmentRuleModal.edit(record)
    },
    add() {
      this.$refs.replenishmentRuleModal.add(this.storageRoom)
    },
    exportExcel() {
      this.$refs.table.openExport()
    }
  }
}
</script>